module.exports = __webpack_public_path__ + "img/title.e58c506c.png";